/**
 * Developed by Spell Solutions for Trivinci Systems, LLC.
 *
 * Developer attribution only. Ownership, licensing, and permitted use are
 * governed by the applicable agreement and applicable law.
 */

/** Build identity, stamped by vite.config.ts at build time.
 *
 *  Worth having because the deployed player is a set of hash-named files behind
 *  a browser cache, so "which build is this?" was only answerable by reading the
 *  hash out of index.html and diffing bundles. When someone reports a fault, the
 *  first thing to establish is whether they are even on the build that was meant
 *  to fix it. `vite dev` does not run the define, hence the fallback. */
export const RK_VERSION: string =
  typeof __RK_VERSION__ === "string" ? __RK_VERSION__ : "dev";

/** Exposed on the document and on window so the running build can be read
 *  without opening the UI: `document.documentElement.dataset.rkVersion`, or
 *  from a terminal against the deployed bundle. */
export function publishVersion(): void {
  try {
    document.documentElement.dataset.rkVersion = RK_VERSION;
    (window as unknown as { RK_VERSION?: string }).RK_VERSION = RK_VERSION;
  } catch {
    /* non-fatal: the visible label in the panel still carries it */
  }
}
